<script>
let eventsBound = [];
let resizeDebounce = null;
let windowHeight = null;
let scrollings = [];
let scrollTime = null;
const scrollingsAverage = function(limit) {
  return Math.ceil(scrollings.slice(Math.max(scrollings.length - limit, 0))
    .reduce((a, s) => {
      return a + s;
    }, 0) / limit);
};
export default {
  data() {
    return {
      slide: 0,
      isScrolling: false,
      duration: 700,
      startTime: null,
      endTime: null,
      scrollTo: null,
      animationFrame: null,
      subslide: -1,
      stopRequest : null,
      touchStart: null,
      iOSHasSizeSet: false,
      quarantine: 0,
      subslidesSeen: []
    }
  },
  computed: {
    slides() {
      return !this.$refs.wrapper? [] : Array.from(this.$refs.wrapper.querySelectorAll('.slide'));
    },
    isIOSSafari() {
      const userAgent = window.navigator.userAgent;
      return userAgent.match(/Safari/i) && (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i));
    }
  },
  watch: {
    slide(val) {
      this.scrollToSlide(val);
      this.subslide = this.subslidesSeen[val] !== undefined? this.subslidesSeen[val] : -1;
      // this.isScrolling = false;
    },
    subslide(val) {
      this.subslidesSeen[this.slide] = Math.max(this.subslidesSeen[this.slide] || -1, val);
      // this.isScrolling = false;
    }
  },
  mounted() {
    windowHeight = window.innerHeight;
    this.bindEvents();
    this.setSafariHeights();
  },
  // created() {
  //   if(window.location.hash) {
  //     const slideId = window.location.hash.replace(/^#/,'');
  //     const slideIndex = this.slides.findIndex((s) => s.dataset.slideId === slideId);
  //     if(slideIndex > -1) {
  //       this.slide = slideIndex;
  //     }
  //   }
  // },
  destroyed() {
    this.unbindEvents();
  },
  methods: {
    bindEvents() {
      eventsBound.push([document,'keydown', this.onKeydown.bind(this)]);
      eventsBound.push([window, 'resize', this.onResize.bind(this)]);
      eventsBound.forEach((e) => {
        e[0].addEventListener(e[1], e[2]);
      });
    },
    unbindEvents() {
      eventsBound.forEach((e) => {
        e[0].removeEventListener(e[1], e[2]);
      });
    },
    setSafariHeights() {
      if(this.isIOSSafari) {
        this.$refs.wrapper.style.maxHeight = '';
        const wrapperHeight = this.$refs.wrapper.offsetHeight;
        this.$refs.wrapper.style.maxHeight = Math.min(wrapperHeight, windowHeight) + 'px';
        this.slides.forEach((s) => {
          s.style.minHeight = Math.min(wrapperHeight, windowHeight) + 'px';
        });
      }
    },
    onNativeScroll(e) {
      // this.iOSHasSizeSet = true;
    },
    goToSlide(index) {
      this.slide = Math.max(0, Math.min(this.slides.length - 1, index));
    },
    onResize() {
      if(resizeDebounce) {
        window.clearTimeout(resizeDebounce);
      }
      resizeDebounce = window.setTimeout(() => {
        resizeDebounce = null;
        this.onResized();
      }, 200);
    },
    onResized() {
      // if(this.isIOSSafari && !this.iOSHasSizeSet && window.innerHeight !== windowHeight) {
      //   this.iOSHasSizeSet = true;
      // } else {
      // }
      windowHeight = window.innerHeight;
      this.setSafariHeights();
      this.scrollToSlide(this.slide, 0);
    },
    onTouchStart(e) {
      this.touchStart = { x : e.touches[0].pageX, y : e.touches[0].pageY };
      // if(!this.isIOSSafari || this.iOSHasSizeSet) {
      // }
    },
    onTouchMove(e) {
      if(this.touchStart) {
        e.preventDefault();
        if(!this.isScrolling) {
          const pos = { x : e.touches[0].pageX, y : e.touches[0].pageY };
          const delta = Math.min(1, Math.max(-1, pos.y - this.touchStart.y));
          if(delta !== 0) {
            this.touchStart = pos;
            this.slideDelta(delta);
          }
        }
      }
    },
    onTouchEnd(e) {
      this.touchStart = null;
    },
    onScroll(e) {

      const value = e.wheelDelta || -e.deltaY || -e.detail;
      const delta = Math.max(-1, Math.min(1, value));

      if(scrollings.length > 149){
        scrollings.shift();
      }
      scrollings.push(Math.abs(value));

      const prevTime = (scrollTime || new Date().getTime());
      scrollTime = new Date().getTime();
      const timeDiff = scrollTime - prevTime;

      if(timeDiff > 200) {
        scrollings = [];
      }

      if(this.isScrolling) {
        e.preventDefault();
        return false;
      }

      const isAccelerating = scrollingsAverage(10) >= scrollingsAverage(70);

      if(!isAccelerating) {
        e.preventDefault();
        return false;
      }

      const horizontalDetection = typeof e.wheelDeltaX !== 'undefined' || typeof e.deltaX !== 'undefined';
      const isScrollingVertically = (Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta)) || (Math.abs(e.deltaX ) < Math.abs(e.deltaY) || !horizontalDetection);

      if(isScrollingVertically) {
        e.preventDefault();
        
        this.slideDelta(delta);
        return false;
      }
    },
    slideDelta(delta) {
      const shouldStayOnSameSlide = this.shouldStayOnSameSlide(delta);
      
      if(shouldStayOnSameSlide === true) {
        this.startScroll(0);
        
      } else if(shouldStayOnSameSlide !== false) {
        this.startScroll(shouldStayOnSameSlide);
      } else if(delta === -1) {
        this.slideNext();
      } else if(delta === 1) {
        this.slidePrev();
      }
    },
    slideNext() {
      this.goToSlide(this.slide + 1);
    },
    slidePrev() {
      this.goToSlide(this.slide - 1);
    },
    onKeydown(e) {
      // Number keys 1-9 = 49-57
      if(e.which >= 49 && e.which <= 57 && (e.which - 49 < this.slides.length)) {
        // Slide to slide {number}
        e.preventDefault();
        this.slide = e.which - 49;
        return false;
      }
      switch(e.which) {
        case 36: // Home
          e.preventDefault();
          this.slide = 0;
          return false;
        case 35: // End
          e.preventDefault();
          this.slide = this.slides.length - 1;
          return false;
        case 9: // Tab
        case 32: // Space
        case 34: // Page down
        case 39: // Right arrow
        case 40: // Down arrow
          e.preventDefault();
          this.slideDelta(-1);
          return false;
        case 33: // Page up
        case 37: // Left arrow
        case 38: // Up arrow
          e.preventDefault();
          this.slideDelta(1);
          return false;
        default:
          break;
      }
    },
    easing(t) {
      return t<.5 ? 2*t*t : -1+(4-2*t)*t;
    },
    scrollToSlide(index, duration = null) {
      const toEl = this.slides[index] || null;
      if(toEl === null) {
        return this.stopScroll();
      }
      const bcr = toEl.getBoundingClientRect();
      // if(toEl.dataset.slideId) {
      //   location.hash = toEl.dataset.slideId;
      // }
      this.startScroll(bcr.top, duration);
    },
    getScrollTop() {
      return this.$refs.wrapper.scrollTop;
    },
    getCurrentSlide() {
      return this.slides[this.slide];
    },
    shouldStayOnSameSlide(delta) {
      const curr = this.getCurrentSlide();
      if(!curr) {
        return false;
      }
      const bcr = curr.getBoundingClientRect();
      const viewportHeight = this.$refs.wrapper.offsetHeight;
      const elementReachesAboveTop = bcr.top < 0;
      const elmentReachesBelowBottom = bcr.top + bcr.height > viewportHeight;

      const subslides = curr.querySelectorAll('.subslide');
      if(subslides.length && delta === -1) {
        if(this.subslide - delta >= -1 && this.subslide - delta < subslides.length) {
          const subslide = subslides.item(this.subslide - delta);
          const sbcr = subslide.getBoundingClientRect();
          const nextPos = Math.min(viewportHeight * 0.8, Math.ceil((bcr.top + bcr.height) - viewportHeight));
          if(subslide && sbcr.top < (nextPos + viewportHeight)) {
            this.subslide -= delta;
            if(sbcr.top >= 0 && sbcr.top + sbcr.height <= viewportHeight) {
              return true;
            } else {
              return Math.min(sbcr.top, (sbcr.top + sbcr.height) - viewportHeight);
            }
          }
        }
      }

      if(this.isScrolling) {
        return false;
      }
      if(delta === 1) {
        const offset = elementReachesAboveTop? -Math.min(viewportHeight * 0.8, Math.abs(bcr.top)) : false;
        return offset && Math.abs(offset) > 45? offset : false;
      } else if(delta === -1) {
        const offset = elmentReachesBelowBottom? Math.min(viewportHeight * 0.8, Math.ceil((bcr.top + bcr.height) - viewportHeight)) : false;
        return offset && Math.abs(offset) > 45? offset : false
      }
    },
    startScroll(to, duration = null) {
      if(this.stopRequest) {
        window.clearTimeout(this.stopRequest);
      }
      this.isScrolling = true;
      this.startTime = new Date().getTime();
      this.endTime = this.startTime + (duration === null? this.duration : duration);
      this.scrollOffset = this.$refs.wrapper.scrollTop;
      this.scrollTo = to;
      this.scrollTick();
    },
    stopScroll() {
      if(this.stopRequest) {
        window.clearTimeout(this.stopRequest);
      }
      this.isScrolling = false;
      this.startTime = null;
      this.endTime = null;
      this.scrollOffset = null;
      this.scrollTo = null;
    },
    scrollTick() {
      if(this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
      }
      const curr = new Date().getTime();
      if(!this.endTime || curr >= this.endTime) {
        this.$refs.wrapper.scrollTop = this.scrollOffset + this.scrollTo;
        this.stopRequest = window.setTimeout(() => {
          this.stopScroll();
        }, this.quarantine);
        return;
      }
      const steps = this.endTime - this.startTime;
      const percent = (curr - this.startTime) / steps;
      const newPos = this.scrollOffset + (this.scrollTo * this.easing(percent));
      this.$refs.wrapper.scrollTop = newPos;
      this.animationFrame = window.requestAnimationFrame(() => {
        this.animationFrame = null;
        this.scrollTick()
      });
    }
  }
}
</script>
<template>
  <div :class="$style.wrapper">
    <div ref="wrapper" :class="[$style['slot-wrapper'], isIOSSafari && !iOSHasSizeSet ? $style['safari-scroll'] : null]" @wheel="onScroll" @keydown="onKeydown" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
      <slot :slide="slide" :subslide="subslide" :go-to-slide="goToSlide.bind(this)" />
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.wrapper {
  height: 100%;
}
.slot-wrapper {
  position: relative;
  max-width: 100vw;
  height: 100%;
  max-height: 100vh;
  overflow: auto;
}
.safari-scroll {
  // height: 100vh;
  // color: #fff;
  // transition: all 0.4s ease;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // height: auto;
  // max-height: none;
}
</style>
